// src/Icons/index.tsx
var IconBase = (props) => <svg
  width={props.size ?? 24}
  height={props.size ?? 24}
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  xmlns="http://www.w3.org/2000/svg"
  {...props}
/>;
var IconX = (props) => <IconBase {...props}>
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </IconBase>;
var IconChevronLeft = (props) => <IconBase {...props}>
    <path d="M13.5 7.5L9 12L13.5 16.5" />
  </IconBase>;
var IconChevronRight = (props) => <IconBase {...props}>
    <path d="M10.5 7.5L15 12L10.5 16.5" />
  </IconBase>;
var IconChevronUp = (props) => <IconBase {...props}>
    <path d="m18 15-6-6-6 6" />
  </IconBase>;
var IconChevronDown = (props) => <IconBase {...props}>
    <path d="m6 9 6 6 6-6" />
  </IconBase>;
var IconChevronUpDown = (props) => <IconBase {...props}>
    <path d="m7 15 5 5 5-5" />
    <path d="m7 9 5-5 5 5" />
  </IconBase>;
var IconCircleChevronDown = (props) => <IconBase {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="m16 10-4 4-4-4" />
  </IconBase>;
var IconCircleChevronLeft = (props) => <IconBase {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="m14 16-4-4 4-4" />
  </IconBase>;
var IconCircleChevronRight = (props) => <IconBase {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="m10 8 4 4-4 4" />
  </IconBase>;
var IconCircleChevronUp = (props) => <IconBase {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="m8 14 4-4 4 4" />
  </IconBase>;
var IconCheck = (props) => <IconBase {...props}>
    <path d="M20 6 9 17l-5-5" />
  </IconBase>;
var IconLoader = (props) => <IconBase {...props}>
    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
  </IconBase>;
var IconCalendar = (props) => <IconBase {...props}>
    <path d="M8 2v4" />
    <path d="M16 2v4" />
    <rect width="18" height="18" x="3" y="4" rx="3" />
    <path d="M3 10h18" />
    <path d="M8 14h.01" />
    <path d="M12 14h.01" />
    <path d="M16 14h.01" />
    <path d="M8 18h.01" />
    <path d="M12 18h.01" />
    <path d="M16 18h.01" />
  </IconBase>;
var IconCircleEllipsis = (props) => <IconBase {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="M17 12h.01" />
    <path d="M12 12h.01" />
    <path d="M7 12h.01" />
  </IconBase>;
var IconTrash = (props) => <IconBase {...props}>
    <path d="M3 6h18" />
    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
  </IconBase>;
var IconPencilLine = (props) => <IconBase {...props}>
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
    <path d="m15 5 3 3" />
  </IconBase>;
var IconMail = (props) => <IconBase {...props}>
    <rect width="20" height="16" x="2" y="4" rx="2" />
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
  </IconBase>;
var IconMessage = (props) => <IconBase {...props}>
    <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
    <path d="M8 12h.01" />
    <path d="M12 12h.01" />
    <path d="M16 12h.01" />
  </IconBase>;
var IconSquarePen = (props) => <IconBase {...props}>
    <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.375 2.625a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4Z" />
  </IconBase>;
var IconSave = (props) => <IconBase {...props}>
    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
    <polyline points="17 21 17 13 7 13 7 21" />
    <polyline points="7 3 7 8 15 8" />
  </IconBase>;
var IconListFilter = (props) => <IconBase {...props}>
    <path d="M3 6h18" />
    <path d="M7 12h10" />
    <path d="M10 18h4" />
  </IconBase>;
var IconRefresh = (props) => <IconBase {...props}>
    <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
    <path d="M21 3v5h-5" />
    <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
    <path d="M8 16H3v5" />
  </IconBase>;
var IconAlert = (props) => <IconBase {...props}>
    <circle cx="12" cy="12" r="10" />
    <line x1="12" x2="12" y1="8" y2="12" />
    <line x1="12" x2="12.01" y1="16" y2="16" />
  </IconBase>;
var IconVolume = (props) => <IconBase {...props}>
    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
    <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
    <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
  </IconBase>;
var IconVolumeWave = (props) => <IconBase {...props}>
    {
  /* 喇叭主体 */
}
    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />

    {
  /* 第一条声波线 - 最短，动画延迟0ms */
}
    <path
  d="M15.5 10.5v3"
  stroke-width="2"
  stroke-linecap="round"
  class="animate-pulse"
  style={{ "animation-delay": "0ms", "animation-duration": "1000ms" }}
/>

    {
  /* 第二条声波线 - 中等，动画延迟200ms */
}
    <path
  d="M18 8.5v7"
  stroke-width="2"
  stroke-linecap="round"
  class="animate-pulse"
  style={{ "animation-delay": "200ms", "animation-duration": "1200ms" }}
/>

    {
  /* 第三条声波线 - 最长，动画延迟400ms */
}
    <path
  d="M20.5 6.5v11"
  stroke-width="2"
  stroke-linecap="round"
  class="animate-pulse"
  style={{ "animation-delay": "400ms", "animation-duration": "1400ms" }}
/>
  </IconBase>;
var IconVolumeX = (props) => <IconBase {...props}>
    {
  /* 喇叭主体 */
}
    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />

    {
  /* 禁用的X标记 */
}
    <line x1="22" y1="9" x2="16" y2="15" />
    <line x1="16" y1="9" x2="22" y2="15" />
  </IconBase>;
var IconCircleCheck = (props) => <IconBase {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="m9 12 2 2 4-4" />
  </IconBase>;
var IconWarning = (props) => <IconBase {...props}>
    <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </IconBase>;
var IconSearch = (props) => <IconBase {...props}>
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.3-4.3" />
  </IconBase>;
var IconCirclePlus = (props) => <IconBase {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="M8 12h8" />
    <path d="M12 8v8" />
  </IconBase>;
var IconExclamationMark = (props) => <svg {...props} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_16792_22297)">
      <path
  d="M7 13.5625C10.6244 13.5625 13.5625 10.6244 13.5625 7C13.5625 3.37563 10.6244 0.4375 7 0.4375C3.37563 0.4375 0.4375 3.37563 0.4375 7C0.4375 10.6244 3.37563 13.5625 7 13.5625Z"
  fill="#4FD1D9"
/>
      <path d="M5.90625 6.08118H8.09375V11.3312H5.90625V6.08118Z" fill="white" />
      <path
  d="M7 4.8562C7.60406 4.8562 8.09375 4.36651 8.09375 3.76245C8.09375 3.15839 7.60406 2.6687 7 2.6687C6.39594 2.6687 5.90625 3.15839 5.90625 3.76245C5.90625 4.36651 6.39594 4.8562 7 4.8562Z"
  fill="white"
/>
    </g>
    <defs>
      <clipPath id="clip0_16792_22297">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>;
var IconMove = (props) => <svg {...props} class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10221" width="16" height="16">
    <path
  d="M977.066667 529.066667c4.266667-8.533333 4.266667-21.333333 0-34.133334-4.266667-4.266667-4.266667-8.533333-8.533334-12.8l-128-128c-17.066667-17.066667-42.666667-17.066667-59.733333 0-17.066667 17.066667-17.066667 42.666667 0 59.733334l55.466667 55.466666H554.666667V187.733333l55.466666 55.466667c8.533333 8.533333 17.066667 12.8 29.866667 12.8s21.333333-4.266667 29.866667-12.8c17.066667-17.066667 17.066667-42.666667 0-59.733333l-128-128c-4.266667-4.266667-8.533333-8.533333-12.8-8.533334-8.533333-4.266667-21.333333-4.266667-34.133334 0-4.266667 4.266667-8.533333 4.266667-12.8 8.533334l-128 128c-17.066667 17.066667-17.066667 42.666667 0 59.733333 17.066667 17.066667 42.666667 17.066667 59.733334 0L469.333333 187.733333V469.333333H187.733333l55.466667-55.466666c17.066667-17.066667 17.066667-42.666667 0-59.733334s-42.666667-17.066667-59.733333 0l-128 128c-4.266667 4.266667-8.533333 8.533333-8.533334 12.8-4.266667 8.533333-4.266667 21.333333 0 34.133334 4.266667 4.266667 4.266667 8.533333 8.533334 12.8l128 128c8.533333 8.533333 17.066667 12.8 29.866666 12.8s21.333333-4.266667 29.866667-12.8c17.066667-17.066667 17.066667-42.666667 0-59.733334L187.733333 554.666667H469.333333v281.6l-55.466666-55.466667c-17.066667-17.066667-42.666667-17.066667-59.733334 0s-17.066667 42.666667 0 59.733333l128 128c4.266667 4.266667 8.533333 8.533333 12.8 8.533334 4.266667 4.266667 12.8 4.266667 17.066667 4.266666s12.8 0 17.066667-4.266666c4.266667-4.266667 8.533333-4.266667 12.8-8.533334l128-128c17.066667-17.066667 17.066667-42.666667 0-59.733333s-42.666667-17.066667-59.733334 0L554.666667 836.266667V554.666667h281.6l-55.466667 55.466666c-17.066667 17.066667-17.066667 42.666667 0 59.733334 8.533333 8.533333 21.333333 12.8 29.866667 12.8s21.333333-4.266667 29.866666-12.8l128-128c4.266667-4.266667 8.533333-8.533333 8.533334-12.8z"
  p-id="10222"
  fill="#8D9BBD"
/>
  </svg>;
var IconLogOut = (props) => <IconBase {...props}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" x2="9" y1="12" y2="12" />
  </IconBase>;
var IconImage = (props) => <IconBase {...props}>
    <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
    <circle cx="9" cy="9" r="2" />
    <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
  </IconBase>;
var IconTriangleAlert = (props) => <IconBase {...props}>
    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
    <path d="M12 9v4" />
    <path d="M12 17h.01" />
  </IconBase>;
var IconPhone = (props) => <IconBase {...props}>
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </IconBase>;
var IconHash = (props) => <IconBase {...props}>
    <line x1="4" x2="20" y1="9" y2="9" />
    <line x1="4" x2="20" y1="15" y2="15" />
    <line x1="10" x2="8" y1="3" y2="21" />
    <line x1="16" x2="14" y1="3" y2="21" />
  </IconBase>;
var IconLanguages = (props) => <IconBase {...props}>
    <path d="m5 8 6 6" />
    <path d="m4 14 6-6 2-3" />
    <path d="M2 5h12" />
    <path d="M7 2h1" />
    <path d="m22 22-5-10-5 10" />
    <path d="M14 18h6" />
  </IconBase>;
var IconKeyRound = (props) => <IconBase {...props}>
    <path d="M2 18v3c0 .6.4 1 1 1h4v-3h3v-3h2l1.4-1.4a6.5 6.5 0 1 0-4-4Z" />
    <circle cx="16.5" cy="7.5" r=".5" fill="currentColor" />
  </IconBase>;
var IconHistory = (props) => <IconBase {...props}>
    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
    <path d="M3 3v5h5" />
    <path d="M12 7v5l4 2" />
  </IconBase>;
var IconDownload = (props) => <IconBase {...props}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" x2="12" y1="15" y2="3" />
  </IconBase>;
var IconMapPin = (props) => <IconBase {...props}>
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </IconBase>;
var IconClock = (props) => <IconBase {...props}>
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </IconBase>;
var IconWrench = (props) => <IconBase {...props}>
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
  </IconBase>;
var IconFlag = (props) => <IconBase {...props}>
    <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
    <line x1="4" x2="4" y1="22" y2="15" />
  </IconBase>;
var IconLock = (props) => <IconBase {...props}>
    <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </IconBase>;
var IconLockOpen = (props) => <IconBase {...props}>
    <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 9.9-1" />
  </IconBase>;
var IconLockKeyhole = (props) => <IconBase {...props}>
    <circle cx="12" cy="16" r="1" />
    <rect x="3" y="10" width="18" height="12" rx="2" />
    <path d="M7 10V7a5 5 0 0 1 10 0v3" />
  </IconBase>;
var IconLockKeyholeOpen = (props) => <IconBase {...props}>
    <circle cx="12" cy="16" r="1" />
    <rect width="18" height="12" x="3" y="10" rx="2" />
    <path d="M7 10V7a5 5 0 0 1 9.33-2.5" />
  </IconBase>;
var IconCloudUpload = (props) => <IconBase {...props}>
    <path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" />
    <path d="M12 12v9" />
    <path d="m16 16-4-4-4 4" />
  </IconBase>;
var IconCreditCard = (props) => <IconBase {...props}>
    <rect width="20" height="14" x="2" y="5" rx="2" />
    <line x1="2" x2="22" y1="10" y2="10" />
  </IconBase>;
var IconMessageSquarePlus = (props) => <IconBase {...props}>
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    <path d="M12 7v6" />
    <path d="M9 10h6" />
  </IconBase>;
var IconMessageSquareText = (props) => <IconBase {...props}>
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    <path d="M13 8H7" />
    <path d="M17 12H7" />
  </IconBase>;
var IconSettings = (props) => <IconBase {...props}>
    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
    <circle cx="12" cy="12" r="3" />
  </IconBase>;
var IconCircleX = (props) => <IconBase {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="m15 9-6 6" />
    <path d="m9 9 6 6" />
  </IconBase>;
var IconUmbrella = (props) => <IconBase {...props}>
    <path d="M22 12a10.06 10.06 1 0 0-20 0Z" />
    <path d="M12 12v8a2 2 0 0 0 4 0" />
    <path d="M12 2v1" />
  </IconBase>;
var IconRouter = (props) => <IconBase {...props}>
    <rect width="20" height="8" x="2" y="14" rx="2" />
    <path d="M6.01 18H6" />
    <path d="M10.01 18H10" />
    <path d="M15 10v4" />
    <path d="M17.84 7.17a4 4 0 0 0-5.66 0" />
    <path d="M20.66 4.34a8 8 0 0 0-11.31 0" />
  </IconBase>;
var IconWallet = (props) => <IconBase {...props}>
    <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1" />
    <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" />
  </IconBase>;
var IconBuilding = (props) => <IconBase {...props}>
    <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
    <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
    <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
    <path d="M10 6h4" />
    <path d="M10 10h4" />
    <path d="M10 14h4" />
    <path d="M10 18h4" />
  </IconBase>;
var IconLink = (props) => <IconBase {...props}>
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </IconBase>;
var IconUser = (props) => <IconBase {...props}>
    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </IconBase>;
var IconCircleDollar = (props) => <IconBase {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" />
    <path d="M12 18V6" />
  </IconBase>;
var IconPawPrint = (props) => <IconBase {...props}>
    <circle cx="11" cy="4" r="2" />
    <circle cx="18" cy="8" r="2" />
    <circle cx="20" cy="16" r="2" />
    <path d="M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z" />
  </IconBase>;
var IconUserX = (props) => <IconBase {...props}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <line x1="17" x2="22" y1="8" y2="13" />
    <line x1="22" x2="17" y1="8" y2="13" />
  </IconBase>;
var IconContact = (props) => <IconBase {...props}>
    <path d="M17 18a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2" />
    <rect width="18" height="18" x="3" y="4" rx="2" />
    <circle cx="12" cy="10" r="2" />
    <line x1="8" x2="8" y1="2" y2="4" />
    <line x1="16" x2="16" y1="2" y2="4" />
  </IconBase>;
var IconBriefcase = (props) => <IconBase {...props}>
    <path d="M12 12h.01" />
    <path d="M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
    <path d="M22 13a18.15 18.15 0 0 1-20 0" />
    <rect width="20" height="14" x="2" y="6" rx="2" />
  </IconBase>;
var IconBan = (props) => <IconBase {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="m4.9 4.9 14.2 14.2" />
  </IconBase>;
var IconHamburger = (props) => <IconBase {...props}>
    <path d="M4 18L20 18" stroke="#000000" stroke-width="2" stroke-linecap="round" />
    <path d="M4 12L20 12" stroke="#000000" stroke-width="2" stroke-linecap="round" />
    <path d="M4 6L20 6" stroke="#000000" stroke-width="2" stroke-linecap="round" />
  </IconBase>;

export {
  IconX,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconChevronDown,
  IconChevronUpDown,
  IconCircleChevronDown,
  IconCircleChevronLeft,
  IconCircleChevronRight,
  IconCircleChevronUp,
  IconCheck,
  IconLoader,
  IconCalendar,
  IconCircleEllipsis,
  IconTrash,
  IconPencilLine,
  IconMail,
  IconMessage,
  IconSquarePen,
  IconSave,
  IconListFilter,
  IconRefresh,
  IconAlert,
  IconVolume,
  IconVolumeWave,
  IconVolumeX,
  IconCircleCheck,
  IconWarning,
  IconSearch,
  IconCirclePlus,
  IconExclamationMark,
  IconMove,
  IconLogOut,
  IconImage,
  IconTriangleAlert,
  IconPhone,
  IconHash,
  IconLanguages,
  IconKeyRound,
  IconHistory,
  IconDownload,
  IconMapPin,
  IconClock,
  IconWrench,
  IconFlag,
  IconLock,
  IconLockOpen,
  IconLockKeyhole,
  IconLockKeyholeOpen,
  IconCloudUpload,
  IconCreditCard,
  IconMessageSquarePlus,
  IconMessageSquareText,
  IconSettings,
  IconCircleX,
  IconUmbrella,
  IconRouter,
  IconWallet,
  IconBuilding,
  IconLink,
  IconUser,
  IconCircleDollar,
  IconPawPrint,
  IconUserX,
  IconContact,
  IconBriefcase,
  IconBan,
  IconHamburger
};
